import React from 'react';
import './CareerGuidanceChoice.css';
import TitleSection from '../Components/TitleSection/TitleSection';
import RT_carreerconsult from '../Assets/Images/26.jpg';
import RT_carreerguide from '../Assets/Images/27.jpg';
import RT_riskambassador from '../Assets/Images/28.jpg';
import RT_carreeroppuritnity from '../Assets/Images/03.jpg';

import RouteTile from '../Components/RouteTile/RouteTile';
import { CSSTransition } from 'react-transition-group';
import Navigation from '../Components/Navigation/Navigation';

export default class CareerGuidanceChoice extends React.Component {
    constructor(props){
        super(props);
        this.state={
            show:false,
            name:'',
            email:'',
        }
    }
      
    componentDidMount(){
        if(!this.props.location.state || !this.props.location.state.name || !this.props.location.state.email){
            this.props.history.push("/");
            return;
        }else{
            this.setState(
                {
                    name:this.props.location.state.name,
                    email:this.props.location.state.email,
                }
            );
        }
        document.addEventListener("keydown", this.handleKeyDown);
        this.setState({show:true});
    }
    
    componentWillUnmount(){
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    navigateToCareerConsult = ()=>{
        this.setState({show:false});
        setTimeout(()=>{
            this.props.history.push('/career-guidance/career-consult',{name:this.state.name, email:this.state.email});
        }, 500)
    }

    navigateToCareerGuide = ()=>{
        this.setState({show:false});
        setTimeout(()=>{
            this.props.history.push('/career-guidance/career-guide/careerguideend', {name:this.state.name, email:this.state.email});
        }, 500)
    }

    navigateToRiskAmbassador = ()=>{
        this.setState({show:false});
        setTimeout(()=>{
            this.props.history.push('/career-guidance/risk-ambassador',{name:this.state.name, email:this.state.email});
        }, 500)
    }

    navigateToCareerOpportunities = ()=>{
        this.setState({show:false});
        setTimeout(()=>{
            this.props.history.push('/career-guidance/career-opportunities',{name:this.state.name, email:this.state.email});
        }, 500)
    }

    render() {
        return(
            <div className="mainWrapper">
                    <CSSTransition
                        classNames="fadeIn"
                        in={this.state.show}
                        unmountOnExit
                        timeout={20000}
                    >
                        <div className="essentialWrapper" >
                            <div className="contentWrapperChoice">
                                 <div className="mobileLeft">
                                <TitleSection subtitle="Career Guidance" title="Choose one of the options you are interested in" />
                                </div>
                                <div className="selectContainer">
                                    <RouteTile image={RT_carreerconsult}  onClick={this.navigateToCareerConsult}         title="Career Consult"      description="Plan a meeting with one of the board members, where you will learn about many great career opportunities."/>
                                    <RouteTile image={RT_carreerguide}  onClick={this.navigateToCareerGuide}           title="Career Guide"          description="The Career Guides help you to get a better understanding of which jobs are available to you when you graduate."/>
                                    <RouteTile image={RT_riskambassador}  onClick={this.navigateToRiskAmbassador}        title="Risk Ambassador"           description="Get in contact with Risk Ambassadors, old Risk Members who already have a job. They hold valuable knowledge on how to land your dream job."/>
                                    <RouteTile image={RT_carreeroppuritnity}  onClick={this.navigateToCareerOpportunities}   title="Career opportunities"           description="Risk offers an extensive database of all available relevant vacancies, internships and traineeships from Risk Partners."/>
                                    <div className="endDot">-</div>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                <Navigation progress = {50} history={this.props.history}/>
            </div>
        );
    }
}